import { useEffect, useState } from 'react';
import LoadingText from '../../../components/LoadingText';
import ErrorDisplay from '../../../components/ErrorDisplay';
import CliError from '../../../utilities/CliError';
import { getLatestBuildWithIntrospection } from '../utilities/buildQueries';
import useExit from '../../../utilities/useExit';

export default function LatestBuildLoader({
  configPath,
  onBuildFound,
}: {
  configPath?: string;
  onBuildFound: (buildId: string) => void;
}) {
  const exit = useExit();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    loadLatestBuild();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadLatestBuild() {
    try {
      const latestBuild = await getLatestBuildWithIntrospection(configPath);
      if (latestBuild) {
        onBuildFound(latestBuild.id);
      } else {
        setError(
          new Error(
            'No builds with introspection found. Please run a build with --introspect',
          ),
        );
        setTimeout(() => exit(), 10);
      }
    } catch (e) {
      setError(CliError.from(e));
      setTimeout(() => exit(), 10);
    }
  }

  if (error) {
    return <ErrorDisplay commandUsed="todesktop introspect" error={error} />;
  }

  return <LoadingText text="Finding latest build with introspection" />;
}
